import FileButton from '@/components/FileButton';
import SectionBox from '@/components/SectionBox';
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

const errorText =
	'Kérjük, szíveskedjen a szükséges nyilatkozatokat megtenni és az elektronikus PDF dokumentumokat letölteni, azok tartalmát megismerni!';

export default {
	mounted() {
		this.setCheckboxData({
			prop: 'canFinalize',
			value: this.validateCheckboxes(this.getCheckboxes),
		});

		this.setCheckboxData({
			prop: 'allFilesAccepted',
			value: false,
		});

        if(!this.computedIsNewContract){
            this.files.push({ title: 'Felmondás', clicked: false, type: 'termination' });
            this.files.push({ title: 'Felmondás megbízás', clicked: false, type: 'termination_authorization' });
        }

        this.errors.allFilesAccepted = errorText;
	},
	components: {
		FileButton,
		SectionBox,
	},
	data() {
        const files = [
            { title: 'Alkuszi megbízás + Igény adatlap', clicked: false, type: 'generated' },
            { title: 'Biztosítási feltételek', clicked: false, type: 'insurer' },
        ];
        if(!this.noStatements) {
            files.push({ title: 'Eurorisk ÁSZF', clicked: false, type: 'normal' });
        }

		return {
			files: files,
			errors: {
				allFilesAccepted: null,
				buildingStatus: null,
                terminationAuthorizationAccepted: null,
                privacyAccept: null,
			},
		};
	},
	computed: {
		...mapGetters(['getCalculation','getQuestionAnswers','getOnMyOwn']),
		...mapGetters('contracting', [
			'getCheckboxes',
			'getBrokerageData',
			'getCheckboxData',
			'getSelectedInsurerCode',
		]),
		isDisabled() {
			return this.files.map(file => file.clicked).includes(false);
		},
        computedIsNewContract() {
            return this.getQuestionAnswers?.isNewContract || this.getOnMyOwn;
        },
		computedLinks() {
            let links = [this?.getBrokerageData?.contract_id ?? null, this.aszf_link,];
            if(!this.noStatements) {
                links.push('Eurorisk_online_ASZF_20241209');
            }
            links.push(this?.getBrokerageData?.contract_id ?? null);
            links.push(this?.getBrokerageData?.contract_id ?? null);
            return links;
		},
	},
	methods: {
		...mapMutations('contracting', ['setCheckboxData']),
		beforeNext(businessProcess= false) {
			return new Promise((resolve, reject) => {

                if(!this.computedIsNewContract && !this.getCheckboxes.terminationAuthorizationAccepted) {
                    this.errors.terminationAuthorizationAccepted = "A továbblépéshez kérjük fogadja el a biztosítás felmondására irányuló megbízást.";
                }

				if(!businessProcess) {
                    this.errors.buildingStatus = null;

                    if (this.aszf_link === 'generali_aszf' && !this.getCheckboxes.buildingStatus) {
                        this.errors.buildingStatus = 'Nem megfelelő állapotú épületre biztosítás nem köthető.';

                        const input = this.getChechboxInput('buildingStatus');
                        input.parentElement.classList.add('checkbox-field');
                        input.parentElement.classList.add('checkbox-field-statement');
                        input.parentElement.classList.toggle('error-field', !this.getCheckboxes.buildingStatus);
                        this.scrollToCheckbox();

                        resolve({ success: false, routeTo: '' });
                    }

                    if(this.euroriskMarketing && this.getCheckboxes.euroriskMarketing === null) {
                        const input = this.getChechboxInput('euroriskMarketing');
                        input.classList.add('checkbox-field');
                        input.classList.add('checkbox-field-statement');
                        input.classList.toggle('error-field', this.getCheckboxes.euroriskMarketing === null);
                        resolve({ success: false, routeTo: '' });
                    }

                    if ((!this.euroriskMarketing || this.getCheckboxes.euroriskMarketing !== null) && (!this.getCheckboxes.allFilesAccepted && !this.downloadNotRequired) || (!this.downloadNotRequired && !this.computedIsNewContract && !this.getCheckboxes.terminationAuthorizationAccepted) || !this.getCheckboxData('canFinalize')) {

                        this.errors.allFilesAccepted = errorText;
                        this.scrollToCheckbox();

                        resolve({ success: false, routeTo: '' });
                    } else {
                        this.errors.allFilesAccepted = null;

                        resolve({ success: true, routeTo: '' });
                    }
                } else{

                    if (!this.getCheckboxes.allFilesAccepted) {
                        this.errors.allFilesAccepted = errorText;
                    }

                    if(this.privacyRequired && !this.getCheckboxes.privacyAccept) {
                        this.errors.privacyAccept = "Adatkezelésről szóló tájákoztatót kötelező elfogadni!";
                    }

                    if (!this.getCheckboxes.allFilesAccepted || (this.privacyRequired && !this.getCheckboxes.privacyAccept) || (!this.computedIsNewContract && !this.getCheckboxes.terminationAuthorizationAccepted) ) {
                        resolve({ success: false, routeTo: '' });
                    } else {
                        this.errors.allFilesAccepted = null;

                        resolve({ success: true, routeTo: '' });
                    }
                }


			});
		},
		scrollToCheckbox() {
			this.checkboxes.forEach(checkbox => {
				const splitted = checkbox.split('.');

				if(splitted[2] !== undefined && splitted[2] === 'required') {
					const input = this.getChechboxInput(splitted[1]);

					if(!this.getCheckboxes.statements[splitted[0]][splitted[1]]) {
						input.parentElement.classList.add('checkbox-field');
						input.parentElement.classList.add('checkbox-field-statement');
						input.parentElement.classList.toggle('error-field', !this.getCheckboxes.statements[splitted[0]][splitted[1]]);
					}
				}
			});

			window.scrollTo({
				behavior: 'smooth',
				top:
					document.querySelector('.error-field:first-of-type').closest('.section').getBoundingClientRect().top -
					document.body.getBoundingClientRect().top -
					30,
			});
		},
		getChechboxInput(selector) {
            if(selector === 'euroriskMarketing') {
                return document.querySelector(`div[id^=${selector}-checkboxes]`);
            }
			return document.querySelector(`input[id^=${selector}]`);
		},
		validateCheckboxes(value) {
			let result = false;

			const required = this.checkboxes.filter(checkbox => {
				const splitted = checkbox.split('.');
				return splitted[2] !== undefined && splitted[2] === 'required';
			});

			if (required.length === 0) {
				result = true;
			}

			_.each(required, checkbox => {
				const splitted = checkbox.split('.');

				result = value.statements[splitted[0]][splitted[1]];

				if (!result) {
					return false;
				}
			});

			if (this.aszf_link === 'generali_aszf') {
				return (value.allFilesAccepted || this.downloadNotRequired)  && result && this.getCheckboxes.buildingStatus;
			}

			return (value.allFilesAccepted || this.downloadNotRequired) && result;
		},
		handleAllFilesAcceptedClick() {
			this.errors.allFilesAccepted = this.isDisabled || !this.getCheckboxes.allFilesAccepted ? errorText : null;
		},
	},
	watch: {
		getCheckboxes: {
			deep: true,
			handler(newVal) {
				this.setCheckboxData({
					prop: 'canFinalize',
					value: this.validateCheckboxes(newVal),
				});
				this.errors.allFilesAccepted = this.getCheckboxes.allFilesAccepted ? null : errorText;

                if (this.getCheckboxes.terminationAuthorizationAccepted !== null) {
                    this.errors.terminationAuthorizationAccepted = this.getCheckboxes.terminationAuthorizationAccepted ? null : "A továbblépéshez kérjük fogadja el a biztosítás felmondására irányuló megbízást.";
                }
                if (this.getCheckboxes.privacyAccept !== null) {
                    this.errors.privacyAccept = this.getCheckboxes.privacyAccept ? null : "Adatkezelésről szóló tájákoztatót kötelező elfogadni!";
                }


                if (this.aszf_link === 'generali_aszf') {
					this.errors.buildingStatus = !this.getCheckboxes.buildingStatus
						? 'Nem megfelelő állapotú épületre biztosítás nem köthető.'
						: null;
				}
			},
		},
	},
};
